import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed top-20 right-8 text-5xl text-white z-30" }
const _hoisted_2 = { class: "text-green" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_4 = { class: "text-red" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" / ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.correctTotal), 1),
    _hoisted_3,
    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.incorrectTotal), 1),
    _hoisted_5,
    _createElementVNode("span", null, _toDisplayString(_ctx.total), 1)
  ]))
}